module.exports = __webpack_public_path__ + "img/15.07fb66de.gif";